import React, { useEffect, useState } from "react";
import { Icons } from "../../../config/MuiIcons.config";
import { Chip, Divider, Grid2, Typography, useMediaQuery } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import {
  APP_MESSAGE,
  ERROR_MESSAGE,
  SNACKBAR_VARIANT,
  USE_FORMIK_SCHEMA,
} from "../../../config/Messages.config";
import AppInputField from "../../../components/CommonReusableComponent/AppInputField/AppInputField";
import MUIDatePicker from "../../../components/MUIDatePicker/MUIDatePicker";
import MUIErrorText from "../../../components/MUIErrorText/MUIErrorText";
import AppButton from "../../../components/CommonReusableComponent/AppButton/AppButton";
import ExpandableList from "./ExpandableList.component";
import AddOrUpdateActivityListModal from "./AddOrUpdateActivityListModal";
import { getUserRoleAndScreens } from "../../../services/authServices/auth.services";
import {
  getAllDepartmentListByBranchId,
  getAllUsersByPlantIdWithoutSuperAdmin,
  getAreasByBranchAndDept,
  getListOfAuditType,
  createAudit,
  editAuditForAdminAndSuperAdmin,
  auditUpdatedByAuditor,
  auditUpdatedByAuditee,
  closeAudit,
  getAllUsersByAccountId,
  getListOfAuditTypeCategories,
} from "../../../helpers/api-functions-helper";
import { useBackdrop } from "../../../contexts/BackDrop.context";
import { useSnackbar } from "../../../contexts/Snackbar.context";
import dayjs from "dayjs";
import { addCurrentTimeInTimeStamp, generateRandomId, getLoggedInUserIsAuditeeOrAuditor, setRequiredDataForDropdown } from "../../../common/CommonFunctions";
import { dataTableColumnsForUpdateActivityStatus, isVarificationStatusWillBeNA, capaShouldBeEmpty, isVarificationStatusWillBeOpened, complianceStatusConfig, checkAuditSubmissionStatus, getStatusChipDetails, InternalAuditInfo } from "./AuditMasterDataTable.config";
import DataTableToUpdateActivityStatusForAudit from "./DataTableToUpdateActivityStatusForAudit";
import { ROLES } from "../../../config/Roles.config";
import { auditStatusConfigForAuditMaster } from "../../../config/AuditStatusConfig";
import AppAutoCompleteField from "../../../components/CommonReusableComponent/AppAutoCompleteField/AppAutoCompleteField";
import WarningModalForFinalSave from "./WarningModalForFinalSave";
import { uploadMultipleFilesInFirebase } from "../../../common/UploadMultipleFilesToFirebaseBucket/UploadMultipleFilesToFirebaseBucket";
import { CLOUD_STOAGE } from "../../../config/CloudStorage.config";

const CreateNewAudit = () => {
  const navigate = useNavigate();
  const params = useParams();
  const isMobileDevice = useMediaQuery("(max-width:599px)");
  const { showBackdrop, hideBackdrop } = useBackdrop();
  const { showSnackbar } = useSnackbar();
  const { assignedBranches, accountId, userUid, role } =
    getUserRoleAndScreens();
  const {
    newAudits,
    pendingAtAuditor,
    auditedByAuditee,
    auditedByAuditor,
    closePending,
    closed,
  } = auditStatusConfigForAuditMaster;

  // Form mode
  const isViewMode = document.location.pathname.includes("/view");
  const isCreateMode = document.location.pathname.includes("/create");
  const isUpdateMode = document.location.pathname.includes("/update");

  // User type
  const isSuperAdmin =
    role && role.toLowerCase() === ROLES.SUPERADMIN ? true : false;

  const isUser = role && role.toLowerCase() === ROLES.USER ? true : false;

  const [dataThroughLocationState, setDataThroughLocationState] =
    useState(null);

  // All the selection states/dropdown
  const [auditTypeCategories, setAuditTypeCategories] = useState([]);
  const [auditTypes, setAuditTypes] = useState([]);
  const [branches, setBranches] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [areas, setAreas] = useState([]);
  const [auditorList, setAuditorList] = useState([]);
  const [auditeeList, setAuditeeList] = useState([]);

  // Global Users List
  const [AllUsers, setAllUsers] = useState([]);

  // Global Audit Type List
  const [allAuditTypes, setAllAuditTypes] = useState([]);

  // Flag to check audit type fetched or not
  const [isAuditTypesAreFetched, setIsAuditTypesAreFetched] = useState(false);

  // Activity modal data
  const [activityList, setActivityList] = useState([]);
  const [activityStatusTable, setActivityStatusTable] = useState([]);
  const [activityListModalData, setActivityListModalData] = useState([]);
  const [suggestion, setSuggestion] = useState({
    auditeesSuggestion: "",
    auditorsSuggestion: "",
  });

  // Show less-more toogle
  const [showMoreOrLess, setShowMoreOrLess] = useState({
    activityList: false,
  });

  // Modal states
  const [modalState, setModalState] = useState({
    activityList: false,
  });

  // loading states
  const [loadingState, setLoadingState] = useState({
    auditTypeCategory: false,
    auditTypes: false,
    departments: false,
    users: false,
    areas: false,
    createAudit: false,
    editAudit: false,
    reviewAuditByAuditor: false,
    reviewAuditByAuditee: false,
    finalCloseOfAudit: false,
    evidenceUpload: false,
  });

  // Warning modal state Auditee & Auditor during final save
  const [finalSaveModalState, setFinalSaveModalState] = useState({
    isOpen: false,
    data: null,
    type: "",
  });

  // Upload Evidence Modal state
  const [uploadEvidenceModalState, setUploadEvidenceModalState] =
    useState(false);

  // Handle the warning modal state for final save
  const handleToggleFinalSaveModalState = (type, data, isOpen = false) => {
    setFinalSaveModalState((prev) => ({
      ...prev,
      type: type,
      data: data || null,
      isOpen: isOpen,
    }));
  };

  // Function to handle the upload evidence modal
  const handleToggleUploadEvidenceModalState = () => {
    setUploadEvidenceModalState((prev) => !prev);
  };

  // Function to toggle show less or more
  const toggleShowMoreOrLess = (Type) => {
    setShowMoreOrLess((e) => ({
      ...e,
      [Type]: !e[Type],
    }));
  };

  // Function to toggle modal state
  const toggleModalState = (Type) => {
    setModalState((e) => ({
      ...e,
      [Type]: !e[Type],
    }));
  };

  // Function to update loading state
  const setLoading = (key, value) => {
    setLoadingState((prev) => {
      return { ...prev, [key]: value };
    });
  };

  // Reusable function to set state values
  const setDropdownState = (setter, label, value) => {
    if (label && value) {
      setter([{ label, value }]);
    } else {
      setter([]); // Set empty array if data is missing
    }
  };

  useEffect(() => {
    const auditDetails = JSON.parse(
      localStorage.getItem(process.env.REACT_APP_DEV_AUDIT_DATA)
    );
    if (auditDetails !== null && auditDetails !== undefined) {
      setDropdownState(
        setAuditTypeCategories,
        auditDetails?.auditTypeCategoryName,
        auditDetails?.auditTypeCategoryId
      );
      setDropdownState(
        setBranches,
        auditDetails?.branchName,
        auditDetails?.branchId
      );
      setDropdownState(
        setDepartments,
        auditDetails?.departmentName,
        auditDetails?.departmentId
      );
      setDropdownState(setAreas, auditDetails?.areaName, auditDetails?.areaId);
      setDropdownState(
        setAuditorList,
        auditDetails?.auditorName,
        auditDetails?.auditorId
      );
      setDropdownState(
        setAuditeeList,
        auditDetails?.auditeeName,
        auditDetails?.auditeeId
      );
      setDataThroughLocationState({ ...auditDetails });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch all active branches
  const fetchAllBranches = () => {
    setRequiredDataForDropdown(setBranches, assignedBranches, "name", "id");
  };

  const getFilteredDataOfUsers = (DATA) => {
    if (!DATA || DATA.length === 0) return { auditee: [], auditor: [] };

    const filteredData = DATA.map((user) => ({
      ...user,
      assignedBranches:
        user.assignedBranches?.filter((branch) => branch.isActive) || [],
    })).reduce(
      (acc, user) => {
        const role = user.roleName.toLowerCase();
        const formattedUser = {
          ...user,
          label: user.userName, // Adding label
          value: user.id, // Adding value
        };

        // if (role === ROLES.USER) acc.auditee.push(formattedUser);
        // if (role === ROLES.USER) acc.auditor.push(formattedUser);

        // Only check role conditions for auditee
        if (role === ROLES.USER || role === ROLES.ADMIN) {
          acc.auditee.push(formattedUser);
        }

        // Include all users in the auditor list (no role condition check)
        acc.auditor.push(formattedUser);

        return acc;
      },
      { auditee: [], auditor: [] }
    );

    return filteredData;
  };

  // Function to filter out the activies acc. to audit Types
  const getActivitiesOfAuditType = (AuditTypeId) => {
    const activityOfAuditType =
      allAuditTypes && allAuditTypes[0]
        ? [...allAuditTypes].filter((audit) => audit.id === AuditTypeId)
        : [];

    if (activityOfAuditType && activityOfAuditType[0]) {
      const { activityList } = activityOfAuditType[0];
      if (!params.auditId) {
        setActivityList(activityList);
        // setActivityListModalData([]);
      } else {
        // const filteredModalDataForActivityList =
        //   dataThroughLocationState.activityList.filter(
        //     (childItem) =>
        //       !activityList.some((parentItem) => parentItem.id === childItem.id)
        //   );

        const modifiedActivityStatusTable = [
          ...dataThroughLocationState.activityList,
        ].map((activity) => {
          return {
            ...activity,
            id: generateRandomId(15),
            name: activity?.name,
            complianceStatus: activity?.complianceStatus || "",
            capa: activity?.capa || "",
            auditorObservation: activity?.auditorObservation || "",
            verificationStatus: activity?.verificationStatus || "",
            remark: activity?.remark || "",
            targetDate: activity?.targetDate || "",
            isCapaApplicable: activity?.isCapaApplicable,
            evidence: activity?.evidence || [],
          };
        });

        setActivityList(modifiedActivityStatusTable);
        setSuggestion({
          auditeesSuggestion:
            dataThroughLocationState?.auditeesSuggestion || "",
          auditorsSuggestion:
            dataThroughLocationState?.auditorsSuggestion || "",
        });
        setActivityStatusTable(modifiedActivityStatusTable);
        console.log(
          "This is activity status table => ",
          modifiedActivityStatusTable
        );
        // setActivityListModalData(filteredModalDataForActivityList);
      }
    }
  };

  // Fetch all audit type categories
  const fetchAllAuditTypeCategories = async () => {
    setLoading("auditTypeCategory", true);
    try {
      const categoryRes = await getListOfAuditTypeCategories(accountId);
      const { statusCode, data } = categoryRes?.data;
      if (statusCode && statusCode === 200) {
        setRequiredDataForDropdown(setAuditTypeCategories, data, "name", "id")
      }
    } catch (error) {
      console.log("Error: ", error);
      showSnackbar(ERROR_MESSAGE.FAILED_TO_FETCH_DATA, SNACKBAR_VARIANT.ERROR);
    } finally {
      setLoading("auditTypeCategory", false);
    }
  }

  // Fetch all audit types
  const fetchAllAuditTypes = () => {
    setLoading("auditTypes", true);
    getListOfAuditType(accountId)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data, success } = response.data;
          if (success && statusCode === 200) {
            setAllAuditTypes(data);
            setRequiredDataForDropdown(setAuditTypes, data, "name", "id")
            setIsAuditTypesAreFetched(true);
          } else {
            setAuditTypes([]);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("auditTypes", false);
      });
  };

  // Fetch all user of a selected branch
  const fetchAllUsersOfBranch = () => {
    setLoading("users", true);
    getAllUsersByAccountId(accountId)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data } = response.data;
          if (statusCode && statusCode === 200) {
            const filteredData = getFilteredDataOfUsers(data);
            const { auditee, auditor } = filteredData;
            setAllUsers([...auditor]);
            if (!params.auditId && !isUpdateMode && !dataThroughLocationState) {
              setAuditorList(auditor);
              setAuditeeList(auditee);
            } else {
              filterUserByDept(auditor, dataThroughLocationState?.departmentId);
            }
          } else {
            setAuditorList([]);
            setAuditeeList([]);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("users", false);
      });
  };

  // Fetch all department by branch id
  const fetchAllDepartmentByBranchId = (branchId) => {
    const payload = {
      branchIds: [branchId],
      accountId: accountId,
    };
    setLoading("departments", true);
    getAllDepartmentListByBranchId(payload)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data } = response.data;
          if (statusCode && statusCode === 200) {
            setRequiredDataForDropdown(setDepartments, data, "name", "id");
          } else {
            setDepartments([]);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("departments", false);
      });
  };

  // Fetch all area by department id
  const fetchAllAreaByDepartmentIdAndBranchId = (branchId, departmentId) => {
    const payload = {
      accountId: accountId,
      branchIds: [branchId],
      departmentIds: [departmentId],
    };
    setLoading("areas", true);
    getAreasByBranchAndDept(payload)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, data } = response.data;
          if (statusCode && statusCode === 200) {
            setRequiredDataForDropdown(setAreas, data, "name", "id");
          } else {
            setAreas([]);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          ERROR_MESSAGE.FAILED_TO_FETCH_DATA,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("areas", false);
      });
  };

  // Create new audit
  const createNewAudit = (DATA) => {
    setLoading("createAudit", true);
    createAudit(DATA)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, success, data, message } = response.data;
          if (!success && statusCode !== 200) {
            showSnackbar(
              data || message || APP_MESSAGE.AUDIT_MASTER.CREATE.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          } else {
            showSnackbar(
              APP_MESSAGE.AUDIT_MASTER.CREATE.SUCCESS,
              SNACKBAR_VARIANT.SUCCESS
            );
            navigate(-1);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.AUDIT_MASTER.CREATE.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("createAudit", false);
      });
  };

  // Edit audit if the status is "New" for super-admin || admin
  const editAudit = (DATA) => {
    setLoading("editAudit", true);
    editAuditForAdminAndSuperAdmin(DATA)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, success, data, message } = response.data;
          if (!success && statusCode !== 200) {
            showSnackbar(
              data || message || APP_MESSAGE.AUDIT_MASTER.UPDATE.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          } else {
            showSnackbar(
              APP_MESSAGE.AUDIT_MASTER.UPDATE.SUCCESS,
              SNACKBAR_VARIANT.SUCCESS
            );
            localStorage.removeItem(process.env.REACT_APP_DEV_AUDIT_DATA);
            navigate(-1);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.AUDIT_MASTER.UPDATE.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("editAudit", false);
      });
  };

  // Update/Review Audit for Auditor
  const updateOrReviewAuditForAuditor = (DATA) => {
    setLoading("reviewAuditByAuditor", true);
    auditUpdatedByAuditor(DATA)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, success, data, message } = response.data;
          if (!success && statusCode !== 200) {
            showSnackbar(
              data || message || APP_MESSAGE.AUDIT_MASTER.UPDATE.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          } else {
            showSnackbar(
              APP_MESSAGE.AUDIT_MASTER.UPDATE.SUCCESS,
              SNACKBAR_VARIANT.SUCCESS
            );
            setLoading("reviewAuditByAuditor", false);
            localStorage.removeItem(process.env.REACT_APP_DEV_AUDIT_DATA);
            navigate(-1);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.AUDIT_MASTER.UPDATE.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("reviewAuditByAuditor", false);
      });
  };

  // Update/Review Audit for Auditee
  const updateOrReviewAuditForAuditee = (DATA) => {
    setLoading("reviewAuditByAuditee", true);
    auditUpdatedByAuditee(DATA)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, success, data, message } = response.data;
          if (!success && statusCode !== 200) {
            showSnackbar(
              data || message || APP_MESSAGE.AUDIT_MASTER.UPDATE.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          } else {
            showSnackbar(
              APP_MESSAGE.AUDIT_MASTER.UPDATE.SUCCESS,
              SNACKBAR_VARIANT.SUCCESS
            );
            // setLoading("reviewAuditByAuditee", false);
            localStorage.removeItem(process.env.REACT_APP_DEV_AUDIT_DATA);
            navigate(-1);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.AUDIT_MASTER.UPDATE.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("reviewAuditByAuditee", false);
      });
  };

  // Close Audit ---Only for Auditor
  const finalCloseOfAuditForAuditor = (DATA) => {
    setLoading("finalCloseOfAudit", true);
    closeAudit(DATA)
      .then((response) => {
        if (response && response.data) {
          const { statusCode, success, data, message } = response.data;
          if (!success && statusCode !== 200) {
            showSnackbar(
              data || message || APP_MESSAGE.AUDIT_MASTER.CLOSED.FAILED,
              SNACKBAR_VARIANT.ERROR
            );
          } else {
            showSnackbar(
              APP_MESSAGE.AUDIT_MASTER.CLOSED.SUCCESS,
              SNACKBAR_VARIANT.SUCCESS
            );
            localStorage.removeItem(process.env.REACT_APP_DEV_AUDIT_DATA);
            navigate(-1);
          }
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
        showSnackbar(
          APP_MESSAGE.AUDIT_MASTER.CLOSED.FAILED,
          SNACKBAR_VARIANT.ERROR
        );
      })
      .finally(() => {
        setLoading("finalCloseOfAudit", false);
      });
  };

  // Function to handle change for audit related things
  const getDataAsPerRequirement = (value, data, key) => {
    if (data && data[0]) {
      const selectedObj = data.find((item) => item.value === value);
      return selectedObj
        ? {
            [`${key}Id`]: selectedObj.value,
            [`${key}Name`]: selectedObj.label,
          }
        : null;
    }

    return null;
  };

  // Function to get required payload acc. auditor and auditee requirements
  const getDataAsPerRequirementOfAuditorOrAuditee = (UserType, Data) => {
    if (Data && Data[0]) {
      if (UserType === "auditor") {
        const dataForAuditor = Data?.map(({ id, ...item }) => {
          return {
            ...item,
            // id: item?.id,
            name: item?.name,
            complianceStatus: item?.complianceStatus,
            capa: item?.capa,
            auditorObservation: item?.auditorObservation,
            targetDate: item?.targetDate,
            evidence: item?.evidence || [],
          };
        });

        return dataForAuditor;
      } else if (UserType === "auditee") {
        const dataForAuditee = Data?.map(({ id, ...item }) => {
          return {
            ...item,
            // id: item?.id,
            name: item?.name,
            complianceStatus: item?.complianceStatus,
            capa: item?.capa,
            targetDate: item?.targetDate,
            verificationStatus: item?.verificationStatus,
            remark: item?.remark,
            isCapaApplicable: item?.isCapaApplicable || false,
            evidence: item?.evidence || [],
          };
        });

        return dataForAuditee;
      }
    }

    return null;
  };

  const isBlobURL = (file) => {
    return typeof file !== "string";
  }
  
  const getNewFilesFromEvidence = (evidenceArray) =>
    evidenceArray.filter(
      (item) => typeof item !== "string" && (item instanceof File || item instanceof Blob || item.path)
    );

  // Function to process all activities and upload evidence
  const processEvidenceUploadsForAllActivities = async ({
    allActivities,
  }) => {
    const updatedActivities = [];

    // console.log("All Activities: ", allActivities);
    // Loop through each activity
    for (const activity of allActivities) {
      const newEvidence = getNewFilesFromEvidence([...activity.evidence]);
      // console.log("New Evidence: ", newEvidence);

      if (newEvidence.length > 0) {
        // If there are files that need to be uploaded
        await new Promise((resolve) => {
          uploadMultipleFilesInFirebase(
            CLOUD_STOAGE.EVIDENCE_MASTER,
            newEvidence,
            (uploadedFiles) => {
              const updatedEvidence = [...activity.evidence].map((item) => {
                // If item is a string (existing URL), return as-is
                if (typeof item === "string") return item;
              
                // Handle newly uploaded files
                const match = uploadedFiles.find((f) => f.name === item.name);
                return match ? match.url : item; // Replace with Firebase URL or keep as-is
              });

              // Push updated activity with new evidence
              updatedActivities.push({
                ...activity,
                evidence: updatedEvidence,
              });
              resolve(); // Resolve the promise once the upload is done
            },
            (val) => setLoading("evidenceUpload", val),
            ({isError, message}) => {
              if (isError) {
                showSnackbar(message, SNACKBAR_VARIANT.ERROR);
              } else {
                showSnackbar(message, SNACKBAR_VARIANT.SUCCESS);
              }
            },
          );
        });
      } else {
        // If no files need to be uploaded, simply add the activity as is
        updatedActivities.push(activity);
      }
    }

    return updatedActivities;
  };

  const handleFinalSaveAfterEvidenceUploadForAuditee = async (DATA) => {
    try {
      const updatedActivityList = await processEvidenceUploadsForAllActivities({
        allActivities: DATA?.activityList,
      });

      // console.log("Updated Activity List: ", updatedActivityList);
  
      const finalPayload = {
        ...DATA,
        activityList: updatedActivityList?.map(({ id, ...item }) => {
          return {
            ...item,
            evidence:
              item?.evidence?.map((evidence) => evidence?.file || evidence) ||
              [],
          };
        }),
      };

      // console.log("Final Payload for Auditee: ", finalPayload);
  
      updateOrReviewAuditForAuditee(finalPayload);
    } catch (err) {
      console.error("Upload failed:", err);
      showSnackbar("Upload failed. Please try again.", SNACKBAR_VARIANT.ERROR);
    }
  };

  // Reset formik validation
  const handleValidationReset = () => {
    setActivityList([]);
    // setActivityListModalData([]);
  };

  const validateAuditDataBeforeSubmission = (data) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return {
        isValid: false,
        message: "No data provided for validation.",
      };
    }

    // Valid compliance status values
    // const validComplianceStatuses = complianceStatusConfig.map(data_ => data_.value);

    // Check for missing or invalid compliance status
    // const missingComplianceStatus = data.filter(item => !item.complianceStatus);
    // if (missingComplianceStatus.length > 0) {
    //   return {
    //     isValid: false,
    //     message: "Progress Status is required for all activities.",
    //     invalidItems: missingComplianceStatus
    //   };
    // }

    // const invalidComplianceStatus = data.filter(
    //   item => !validComplianceStatuses.includes(item.complianceStatus)
    // );
    // if (invalidComplianceStatus.length > 0) {
    //   return {
    //     isValid: false,
    //     message: "Invalid Compliance Status.",
    //     invalidItems: invalidComplianceStatus
    //   };
    // }

    // Check for missing CAPA or Target Date when required
    const invalidEntries = data.filter(
      (item) =>
        (item.complianceStatus === "Area for Improvement" ||
          item.complianceStatus === "Not Confirmed") &&
        // (!item.capa || !item.capa.trim() || !item.targetDate)
        !item.targetDate
    );

    if (invalidEntries.length > 0) {
      return {
        isValid: false,
        message:
          // "CAPA and Target Date are required for 'Area for Improvement' or 'Not Confirmed' activities.",
          "Target Date are required for 'Area for Improvement' or 'Not Confirmed' activities.",
        invalidItems: invalidEntries,
      };
    }

    return { isValid: true };
  };

  // ---------------- Role Defination ----------------
  // Logged in user is Admin
  const isAdmin = role && role.toLowerCase() === ROLES.ADMIN ? true : false;

  // Logged in user is Auditor
  const isAuditor =
    dataThroughLocationState &&
    getLoggedInUserIsAuditeeOrAuditor(
      ROLES.AUDITOR,
      dataThroughLocationState?.auditorId
    ).isAuditor
      ? true
      : false;

  // Logged in user is Auditee
  const isAuditee =
    dataThroughLocationState &&
    getLoggedInUserIsAuditeeOrAuditor(
      ROLES.AUDITEE,
      dataThroughLocationState?.auditeeId
    ).isAuditee
      ? true
      : false;

  // Formik form validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      auditTypeCategoryId:
        (params?.auditId && dataThroughLocationState?.auditTypeCategoryId) || "",
      auditTypeId:
        (params?.auditId && dataThroughLocationState?.auditTypeId) || "",
      branchId: (params?.auditId && dataThroughLocationState?.branchId) || "",
      departmentId:
        (params?.auditId && dataThroughLocationState?.departmentId) || "",
      areaId: (params?.auditId && dataThroughLocationState?.areaId) || "",
      startDate: (params?.auditId && dataThroughLocationState?.startDate) || "",
      endDate: (params?.auditId && dataThroughLocationState?.endDate) || "",
      auditorId: (params?.auditId && dataThroughLocationState?.auditorId) || "",
      auditeeId: (params?.auditId && dataThroughLocationState?.auditeeId) || "",
    },
    validationSchema: Yup.object({
      auditTypeCategoryId: Yup.string().required(
        USE_FORMIK_SCHEMA.AUDIT_MASTER.SELECT_AUDIT_TYPE_CATEGORY
      ),
      auditTypeId: Yup.string().required(
        USE_FORMIK_SCHEMA.AUDIT_MASTER.SELECT_AUDIT_TYPE
      ),
      branchId: Yup.string().required(
        USE_FORMIK_SCHEMA.AUDIT_MASTER.SELECT_BRANCH
      ),
      departmentId: Yup.string().required(
        USE_FORMIK_SCHEMA.AUDIT_MASTER.SELECT_DEPARTMENT
      ),
      areaId: Yup.string().required(USE_FORMIK_SCHEMA.AUDIT_MASTER.SELECT_AREA),
      startDate: Yup.string().required(
        USE_FORMIK_SCHEMA.AUDIT_MASTER.SELECT_START_DATE
      ),
      endDate: Yup.string().required(
        USE_FORMIK_SCHEMA.AUDIT_MASTER.SELECT_END_DATE
      ),
      auditorId: Yup.string().required(
        USE_FORMIK_SCHEMA.AUDIT_MASTER.SELECT_AUDITOR
      ),
      auditeeId: Yup.string().required(
        USE_FORMIK_SCHEMA.AUDIT_MASTER.SELECT_AUDITEE
      ),
    }),
    onSubmit: (values) => {
      const {
        auditTypeCategoryId,
        auditTypeId,
        branchId,
        departmentId,
        areaId,
        auditorId,
        auditeeId,
        startDate,
        endDate,
      } = values;
      // Get final activity list
      const revised_activity_list_For_Create = [...activityList].map((obj) => {
        return {
          name: obj.name,
        };
      });
      const auditTypeCategoryList = [...allAuditTypes].map((atc) => {
        return {
          ...atc,
          value: atc.id,
          label: atc.name
        }
      });
      const create_payload = {
        ...getDataAsPerRequirement(auditTypeCategoryId, auditTypeCategories, "auditTypeCategory"),
        ...getDataAsPerRequirement(auditTypeId, auditTypeCategoryList, "auditType"),
        ...getDataAsPerRequirement(branchId, branches, "branch"),
        ...getDataAsPerRequirement(departmentId, departments, "department"),
        ...getDataAsPerRequirement(areaId, areas, "area"),
        ...getDataAsPerRequirement(auditorId, auditorList, "auditor"),
        ...getDataAsPerRequirement(auditeeId, auditeeList, "auditee"),
        startDate: addCurrentTimeInTimeStamp(startDate),
        endDate: addCurrentTimeInTimeStamp(endDate),
        accountId: accountId,
        createdBy: userUid,
        activityList: [...revised_activity_list_For_Create],
      };
      if (!params.auditId) {
        if (auditeeId === auditorId) {
          showSnackbar(
            "Auditor and Auditee cannot be the same. Please select different users.",
            SNACKBAR_VARIANT.ERROR
          );
        } else {
          console.log("This is create payload => ", create_payload);
          createNewAudit(create_payload);
        }
      }
      // else if (
      //   params?.auditId &&
      //   isUpdateMode &&
      //   (isSuperAdmin || isAdmin) &&
      //   !isAuditor && !isAuditee &&
      //   isAuditStatusNew
      // ) {
      //   const edit_payload = {
      //     ...getDataAsPerRequirement(auditorId, auditorList, "auditor"),
      //     ...getDataAsPerRequirement(auditeeId, auditeeList, "auditee"),
      //     id: params?.auditId,
      //     accountId: accountId,
      //     updatedBy: userUid,
      //   };
      //   if (auditeeId === auditorId) {
      //     showSnackbar(
      //       "Auditor and Auditee cannot be the same. Please select different users.",
      //       SNACKBAR_VARIANT.ERROR
      //     );
      //   } else {
      //     editAudit(edit_payload);
      //   }
      // }
      else if (params?.auditId && isUpdateMode && isAuditor) {
        const activityStatusTableArray =
          getDataAsPerRequirementOfAuditorOrAuditee(
            "auditor",
            activityStatusTable
          );

        const payloadForAuditor = {
          auditId: dataThroughLocationState?.id,
          accountId: accountId,
          updatedBy: userUid,
          auditorsSuggestion: suggestion.auditorsSuggestion,
          activityList: activityStatusTableArray,
        };

        // Activity validation
        const result = validateAuditDataBeforeSubmission(
          activityStatusTableArray
        );

        if (!result.isValid) {
          showSnackbar(result.message, SNACKBAR_VARIANT.ERROR);
        } else {
          console.log("This is auditor => : ", isAuditor);
          console.log("updated by auditor => : ", payloadForAuditor);
          const isAuditSubmissionStatus = checkAuditSubmissionStatus(
            activityStatusTableArray,
            "Auditor"
          );

          if (
            isAuditSubmissionStatus.showModal &&
            isAuditSubmissionStatus.newStatus === auditedByAuditor
          ) {
            handleToggleFinalSaveModalState("Auditor", payloadForAuditor, true);
            console.log("isAuditSubmissionStatus => ", isAuditSubmissionStatus);
          } else {
            updateOrReviewAuditForAuditor(payloadForAuditor);
          }
        }
      } else if (params?.auditId && isUpdateMode && isAuditee) {
        // const activityStatusTableArray =
        //   getDataAsPerRequirementOfAuditorOrAuditee(
        //     "auditee",
        //     activityStatusTable
        //   );

        const payloadForAuditee = {
          auditId: dataThroughLocationState?.id,
          accountId: accountId,
          updatedBy: userUid,
          auditeesSuggestion: suggestion.auditeesSuggestion,
          activityList: activityStatusTable,
        };
        console.log("This is auditee => : ", isAuditee);
        console.log("This for auditee => ", payloadForAuditee);
        const isAuditSubmissionStatus = checkAuditSubmissionStatus(
          activityStatusTable,
          "Auditee"
        );
        if (
          isAuditSubmissionStatus.showModal &&
          isAuditSubmissionStatus.newStatus === closePending
        ) {
          handleToggleFinalSaveModalState("Auditee", payloadForAuditee, true);
        } else {
          // updateOrReviewAuditForAuditee(payloadForAuditee);
          handleFinalSaveAfterEvidenceUploadForAuditee(payloadForAuditee);
        }
      }
    },
    onReset: () => {
      handleValidationReset();
    },
  });

  const { branchId, departmentId, auditTypeCategoryId } = validation.values;

  const resetValidationField = (fieldName, Value) => {
    validation.setFieldValue(fieldName, Value);
    validation.setFieldTouched(fieldName, "");
  };

  const resetDataOnBranchSelection = () => {
    resetValidationField("departmentId", "");
    resetValidationField("areaId", "");
    setDepartments([]);
    setAuditeeList([]);
    setAuditorList([]);
  };

  useEffect(() => {
    fetchAllAuditTypes();
    if (!params.auditId) {
      fetchAllAuditTypeCategories();
      fetchAllUsersOfBranch();
      fetchAllBranches();
    }
  }, [params.auditId]);

  useEffect(() => {
    if (params.auditId && isAuditTypesAreFetched && dataThroughLocationState) {
      getActivitiesOfAuditType(dataThroughLocationState?.auditTypeId);
    }
  }, [isAuditTypesAreFetched, dataThroughLocationState, params.auditId]);

  // Handle API calls based on form mode
  useEffect(() => {
    if (isUpdateMode && params.auditId && dataThroughLocationState) {
      // Update/View Mode: Do NOT fetch departments/areas,
      // only fetch users if Admin/SuperAdmin and status is "New"
      if (
        (isAdmin || isSuperAdmin) &&
        dataThroughLocationState?.status === "New"
      ) {
        // fetchAllUsersOfBranch(dataThroughLocationState?.branchId);
        fetchAllUsersOfBranch();
      }
    }
  }, [isUpdateMode, isViewMode, dataThroughLocationState]);

  // Fetch areas when department changes (Only if branchId exists)
  useEffect(() => {
    if (!params.auditId) {
      if (departmentId && branchId) {
        fetchAllAreaByDepartmentIdAndBranchId(branchId, departmentId);
      } else {
        setAreas([]);
      }
    }
  }, [departmentId, branchId, params.auditId]);

  // Handle global loading state
  useEffect(() => {
    // Global loading state
    const isAllLoadingComplete = Object.values(loadingState).every(
      (status) => !status
    );

    if (!isAllLoadingComplete) {
      showBackdrop();
    } else {
      hideBackdrop();
    }
  }, [loadingState]);

  const disablePreviousDateForEndDate = (date) => {
    const selectedDate = dayjs(date).startOf("day");
    const minDate = dayjs(validation.values.startDate).startOf("day");
    return selectedDate.isBefore(minDate);
  };

  const isBranchOrDeptSelected = branchId && departmentId ? true : false;
  const isAuditTypeCategorySelected = auditTypeCategoryId ? true : false;

  // Audit flags
  const isAuditStatusNew =
    params?.auditId && dataThroughLocationState?.status === newAudits
      ? true
      : false;

  const isAuditReviewPendingAtAuditor =
    params?.auditId && dataThroughLocationState?.status === pendingAtAuditor
      ? true
      : false;

  const isAuditReviewedByAuditor =
    params?.auditId && dataThroughLocationState?.status === auditedByAuditee
      ? true
      : false;

  const isAuditReviewedByAuditee =
    params?.auditId && dataThroughLocationState?.status === auditedByAuditor
      ? true
      : false;

  const isAuditInClosePendingStatus =
    params?.auditId && dataThroughLocationState?.status === closePending
      ? true
      : false;

  const isAuditInClosedStatus =
    params?.auditId && dataThroughLocationState?.status === closed
      ? true
      : false;

  // Enable dropdown only if it's update mode, user is Super Admin or Admin, and audit status is "New"
  const isDropdownDisabled =
    isViewMode || // Always disabled in View Mode
    (isAuditor && !isSuperAdmin && !isAdmin) || // Disabled for Auditor
    (isAuditee && !isSuperAdmin && !isAdmin) || // Disabled for Auditee
    (isUpdateMode &&
      !(isSuperAdmin || isAdmin) &&
      isAuditStatusNew === false) ||
    isAuditReviewPendingAtAuditor ||
    isAuditReviewedByAuditor ||
    isAuditReviewedByAuditee ||
    isAuditInClosePendingStatus ||
    isAuditInClosedStatus;

  // Check if the update button should be hidden
  // For Admin & Super-Admin
  const shouldHideUpdateButton =
    (isAdmin || isSuperAdmin) &&
    !isAuditee &&
    !isAuditor &&
    params?.auditId &&
    dataThroughLocationState?.status === newAudits;

  // For Auditee & Auditor
  const shouldHideUpdateButtonForAuditeeAndAuditor =
    (isAuditor || isAuditee) &&
    params?.auditId &&
    (dataThroughLocationState?.status === closePending ||
      dataThroughLocationState?.status === closed);

  // Check is audit started or not (in case of future audit)
  const isAuditStarted = dataThroughLocationState?.isAuditStarted
    ? true
    : false;

  // Show the 'Save Changes' button only if: 
  const showSaveChangesBtn =
    params?.auditId &&
    isUpdateMode &&
    (isSuperAdmin || isAdmin) &&
    isAuditStatusNew;

  // Function to handle change in activity status table
  const handleChangeInActivityStatusTable = (id, field, value) => {
    var updatedData = activityStatusTable.map((item) => {
      if (item.id === id) {
        let updatedItem = { ...item, [field]: value };

        // Apply conditions based on the 'complianceStatus' field
        if (field === "complianceStatus") {
          if (isVarificationStatusWillBeOpened.includes(value)) {
            updatedItem.verificationStatus = "Open";
          } else if (value === "Confirmed") {
            updatedItem.verificationStatus = "Confirmed";
          } else if ([...isVarificationStatusWillBeNA].includes(value)) {
            updatedItem.verificationStatus = "Not Applicable";
          }

          // Clear 'capa' field when complianceStatus is
          // 'Not Applicable', 'Not Audited', or 'Confirmed'
          if ([...capaShouldBeEmpty].includes(value)) {
            // updatedItem.capa = "";
            updatedItem.targetDate = "";
          }
        }

        return updatedItem;
      }
      return item;
    });

    setActivityStatusTable(updatedData);
  };

  // Function to handle Suggestion Change
  const handleSuggestion = (event) => {
    const { name, value } = event?.target;
    setSuggestion((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const chipDetails = () => {
    const status = getStatusChipDetails(
      !params?.auditId || isAuditStatusNew
        ? newAudits
        : dataThroughLocationState?.status
    );
    return status;
  };

  const filterUserByDept = (Data, deptId) => {
    // const users = [...AllUsers];
    const uniqueUsers = Data.filter(
      (user, index, self) => index === self.findIndex((u) => u.id === user.id)
    );

    const filteredUserByDept = uniqueUsers.filter((user) => {
      return (
        // user.roleName.toLowerCase() !== ROLES.ADMIN &&
        user.roleName.toLowerCase() !== "super admin" &&
        Array.isArray(user.assignedBranches) && // Ensure assignedBranches exists
        user.assignedBranches.some(
          (branch) =>
            Array.isArray(branch.assignedDepartments) && // Ensure assignedDepartments exists
            branch.assignedDepartments.some(
              (department) => department.id === deptId
            )
        )
      );
    });

    // console.log("filteredUserByDept: ", filteredUserByDept);
    setAuditeeList(filteredUserByDept);
    setAuditorList(uniqueUsers);

    if (!params.auditId && !dataThroughLocationState) {
      resetValidationField("auditorId", "");
      resetValidationField("auditeeId", "");
    }
  };

  // Function to filter audit types by category
  const filterAuditTypeByCategory = (Data, categoryId) => {
    if (!Data || !categoryId || Data.length === 0) return;

    const filteredAuditTypes = [...Data].filter(
      (auditType) => auditType.auditTypeCategoryId === categoryId
    );
    resetValidationField("auditTypeId", "");
    setRequiredDataForDropdown(setAuditTypes, filteredAuditTypes, "name", "id")
    setActivityList([]);
  }

  const handleChangeForFields = (event, fieldName, value) => {
    if (value) {
      const event_ = {
        ...event,
        target: {
          ...event?.target,
          name: fieldName,
          id: fieldName,
          value: value || "",
        },
      };
      validation.handleChange(event_);
    }
  };

  const EditAudit = () => {
    const auditorId = validation?.values.auditorId;
    const auditeeId = validation?.values.auditeeId;
    const edit_payload = {
      ...getDataAsPerRequirement(auditorId, auditorList, "auditor"),
      ...getDataAsPerRequirement(auditeeId, auditeeList, "auditee"),
      id: params?.auditId,
      accountId: accountId,
      updatedBy: userUid,
    };
    if (auditeeId === auditorId) {
      showSnackbar(
        "Auditor and Auditee cannot be the same. Please select different users.",
        SNACKBAR_VARIANT.ERROR
      );
    } else {
      editAudit(edit_payload);
    }
  };

  // Function for final save for Auditor & Auditee
  const handleFinalSave = (modalType, data) => {
    if (!modalType || !data) return;

    if (modalType === "Auditor" && data) {
      updateOrReviewAuditForAuditor(data);
    }

    if (modalType === "Auditee" && data) {
      // updateOrReviewAuditForAuditee(data);
      handleFinalSaveAfterEvidenceUploadForAuditee(data);
    }

    if (modalType === "Close Audit" && data) {
      finalCloseOfAuditForAuditor(data);
    }
  };

  return (
    <React.Fragment>
      {modalState.activityList ? (
        <AddOrUpdateActivityListModal
          Open={modalState.activityList}
          ToggleDialogBox={(type) => toggleModalState(type)}
          Title={
            params && params.auditId
              ? "Update Activities"
              : "Add More Activities"
          }
          MandatoryActivityList={[...activityList]}
          RecentSelectedActivityList={[...activityListModalData]}
          SetActivityListModalData={setActivityListModalData}
          IsUpdateMode={params && params.auditId ? true : false}
        />
      ) : null}

      {finalSaveModalState.isOpen ? (
        <WarningModalForFinalSave
          ModalType={finalSaveModalState.type}
          Open={finalSaveModalState.isOpen}
          ToggleFunction={handleToggleFinalSaveModalState}
          OnSubmit={(modalType, data) => handleFinalSave(modalType, data)}
          Data={finalSaveModalState.data}
        />
      ) : null}

      <div
        className="page-content"
        style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}
      >
        <Grid2 container className="mb-2" alignItems={"center"}>
          <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
            <div className="d-flex align-items-center gap-2 py-1">
              <Icons.KeyboardBackspaceIcon
                className="cursor-pointer"
                style={{ color: "GrayText" }}
                onClick={() => {
                  localStorage.removeItem(process.env.REACT_APP_DEV_AUDIT_DATA);
                  navigate(-1);
                }}
              />
              <Typography className="inter-medium-500">
                {!params?.auditId && isCreateMode
                  ? "Create New Audit"
                  : params?.auditId && isViewMode
                  ? "View Audit"
                  : params?.auditId && isUpdateMode && "Update Audit"}
              </Typography>
            </div>
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 8, md: 8, lg: 8 }}>
            <div className="d-flex flex-wrap align-items-center justify-content-sm-end justify-content-between w-100">
              {!isCreateMode && (
                <Typography className="inter-medium-500 me-2">
                  {`ID: ${dataThroughLocationState?.auditId} | `}
                </Typography>
              )}
              {!isCreateMode && (
                <Typography className="inter-medium-500 me-2">
                  {`Created By: ${
                    dataThroughLocationState?.createdByName || "Not Available"
                  } | `}
                </Typography>
              )}
              <Chip
                sx={{
                  borderRadius: "4px",
                  border: `1px solid ${chipDetails().textColor}`,
                  background: chipDetails().pillColor,
                  color: chipDetails().textColor,
                }}
                size="small"
                className="px-2"
                label={chipDetails().status}
              />
            </div>
          </Grid2>
        </Grid2>
        <Divider
          className="mb-1"
          style={{ color: "GrayText", border: "0.02rem solid GrayText" }}
        />

        {((!params?.auditId && isCreateMode) || isUpdateMode) && (
          <Grid2 container spacing={2}>
            <Grid2 size={12}>
              <div className="text-end">
                <Typography variant="caption">
                  {" "}
                  Need help? <InternalAuditInfo />
                </Typography>
              </div>
            </Grid2>
          </Grid2>
        )}

        <Grid2 container rowSpacing={1} columnSpacing={2} className="mb-2">
          <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
            <Typography variant="body2" className="inter-regular-400 py-1">
              Audit Type Category
            </Typography>
            <AppAutoCompleteField
              IsMultiple={false}
              TextInputName={"auditTypeCategoryId"}
              TextInputId={"auditTypeCategoryId"}
              Id={"auditTypeCategoryId"}
              TextInputPlaceholder={"Select Audit Type Category"}
              Options={auditTypeCategories || []}
              Disabled={isViewMode || params.auditId ? true : false}
              Value={validation.values.auditTypeCategoryId || ""}
              HandleOnBlur={validation.handleBlur}
              HandleOnChange={(event, value_) => {
                handleChangeForFields(
                  event,
                  "auditTypeCategoryId",
                  value_?.value
                );
                if (value_?.value)
                  filterAuditTypeByCategory(allAuditTypes, value_?.value);
              }}
              TextInputError={
                validation.touched.auditTypeCategoryId &&
                validation.errors.auditTypeCategoryId
                  ? true
                  : false
              }
              TextInputHelperText={
                validation.touched.auditTypeCategoryId &&
                validation.errors.auditTypeCategoryId
                  ? validation.errors.auditTypeCategoryId
                  : null
              }
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
            <Typography variant="body2" className="inter-regular-400 py-1">
              Audit Type
            </Typography>
            {/* <AppInputField
              Name={"auditTypeId"}
              Id={"auditTypeId"}
              PlaceHolder={"Select audit type"}
              IsSelect={true}
              SelectOptions={auditTypes || []}
              Disabled={isViewMode || params.auditId ? true : false}
              Value={validation.values.auditTypeId || ""}
              OnBlur={validation.handleBlur}
              OnChange={(event) => {
                validation.handleChange(event);
                const { value } = event?.target;
                getActivitiesOfAuditType(value);
              }}
              Error={
                validation.touched.auditTypeId && validation.errors.auditTypeId
                  ? true
                  : false
              }
              HelperText={validation.errors.auditTypeId}
            /> */}
            <AppAutoCompleteField
              IsMultiple={false}
              TextInputName={"auditTypeId"}
              TextInputId={"auditTypeId"}
              Id={"auditTypeId"}
              TextInputPlaceholder={"Select Audit Type"}
              Options={auditTypes || []}
              Disabled={
                isViewMode || !isAuditTypeCategorySelected || params.auditId
                  ? true
                  : false
              }
              Value={validation.values.auditTypeId || ""}
              HandleOnBlur={validation.handleBlur}
              HandleOnChange={(event, value_) => {
                handleChangeForFields(event, "auditTypeId", value_?.value);
                if (value_?.value) getActivitiesOfAuditType(value_?.value);
              }}
              TextInputError={
                validation.touched.auditTypeId && validation.errors.auditTypeId
                  ? true
                  : false
              }
              TextInputHelperText={
                validation.touched.auditTypeId && validation.errors.auditTypeId
                  ? validation.errors.auditTypeId
                  : null
              }
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
            <Typography variant="body2" className="inter-regular-400 py-1">
              Branch
            </Typography>
            {/* <AppInputField
              Name={"branchId"}
              Id={"branchId"}
              PlaceHolder={"Select Branch"}
              IsSelect={true}
              SelectOptions={branches || []}
              Disabled={isViewMode || params.auditId ? true : false}
              Value={validation.values.branchId || ""}
              OnBlur={validation.handleBlur}
              OnChange={(event) => {
                const { value } = event?.target;
                validation.handleChange(event);
                resetDataOnBranchSelection();
                if (isCreateMode && !params.auditId) {
                  fetchAllDepartmentByBranchId(value);
                  fetchAllUsersOfBranch(value);
                }
              }}
              Error={
                validation.touched.branchId && validation.errors.branchId
                  ? true
                  : false
              }
              HelperText={validation.errors.branchId}
            /> */}
            <AppAutoCompleteField
              IsMultiple={false}
              TextInputName={"branchId"}
              TextInputId={"branchId"}
              Id={"branchId"}
              TextInputPlaceholder={"Select Branch"}
              Options={branches || []}
              Disabled={isViewMode || params.auditId ? true : false}
              Value={validation.values.branchId || ""}
              HandleOnBlur={validation.handleBlur}
              HandleOnChange={(event, value_) => {
                handleChangeForFields(event, "branchId", value_?.value || "");
                if (value_?.value) {
                  resetDataOnBranchSelection();
                  if (isCreateMode && !params.auditId) {
                    fetchAllDepartmentByBranchId(value_?.value);
                    // fetchAllUsersOfBranch(value_?.value);
                  }
                }
              }}
              TextInputError={
                validation.touched.branchId && validation.errors.branchId
                  ? true
                  : false
              }
              TextInputHelperText={
                validation.touched.branchId && validation.errors.branchId
                  ? validation.errors.branchId
                  : null
              }
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
            <Typography variant="body2" className="inter-regular-400 py-1">
              Department
            </Typography>
            {/* <AppInputField
              Name={"departmentId"}
              Id={"departmentId"}
              PlaceHolder={"Select Department"}
              IsSelect={true}
              SelectOptions={departments || []}
              Disabled={isViewMode || params.auditId ? true : false}
              Value={validation.values.departmentId || ""}
              OnBlur={validation.handleBlur}
              OnChange={(event) => {
                const { value } = event?.target;
                validation.handleChange(event);
                resetValidationField("areaId", "");
                setAreas([]);
                filterUserByDept(AllUsers, value);
              }}
              Error={
                validation.touched.departmentId &&
                validation.errors.departmentId
                  ? true
                  : false
              }
              HelperText={validation.errors.departmentId}
            /> */}
            <AppAutoCompleteField
              IsMultiple={false}
              TextInputName={"departmentId"}
              TextInputId={"departmentId"}
              Id={"departmentId"}
              TextInputPlaceholder={"Select Department"}
              Options={departments || []}
              Disabled={isViewMode || params.auditId ? true : false}
              Value={validation.values.departmentId || ""}
              HandleOnBlur={validation.handleBlur}
              HandleOnChange={(event, value_) => {
                handleChangeForFields(
                  event,
                  "departmentId",
                  value_?.value || ""
                );
                if (value_?.value) {
                  resetValidationField("areaId", "");
                  setAreas([]);
                  filterUserByDept(AllUsers, value_?.value);
                }
              }}
              TextInputError={
                validation.touched.departmentId &&
                validation.errors.departmentId
                  ? true
                  : false
              }
              TextInputHelperText={
                validation.touched.departmentId &&
                validation.errors.departmentId
                  ? validation.errors.departmentId
                  : null
              }
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
            <Typography variant="body2" className="inter-regular-400 py-1">
              Area
            </Typography>
            {/* <AppInputField
              Name={"areaId"}
              Id={"areaId"}
              PlaceHolder={"Select Area"}
              IsSelect={true}
              SelectOptions={areas || []}
              Disabled={isViewMode || params.auditId ? true : false}
              Value={validation.values.areaId || ""}
              OnBlur={validation.handleBlur}
              OnChange={validation.handleChange}
              Error={
                validation.touched.areaId && validation.errors.areaId
                  ? true
                  : false
              }
              HelperText={validation.errors.areaId}
            /> */}
            <AppAutoCompleteField
              IsMultiple={false}
              TextInputName={"areaId"}
              TextInputId={"areaId"}
              Id={"areaId"}
              TextInputPlaceholder={"Select Area"}
              Options={areas || []}
              Disabled={isViewMode || params.auditId ? true : false}
              Value={validation.values.areaId || ""}
              HandleOnBlur={validation.handleBlur}
              HandleOnChange={(event, value_) => {
                handleChangeForFields(event, "areaId", value_?.value || "");
              }}
              TextInputError={
                validation.touched.areaId && validation.errors.areaId
                  ? true
                  : false
              }
              TextInputHelperText={
                validation.touched.areaId && validation.errors.areaId
                  ? validation.errors.areaId
                  : null
              }
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
            <Typography variant="body2" className="inter-regular-400 py-1">
              Start Date
            </Typography>
            <MUIDatePicker
              Name={"startDate"}
              Id={"startDate"}
              Disabled={isViewMode || params.auditId ? true : false}
              Value={validation.values.startDate || ""}
              OnBlur={validation.handleBlur}
              OnChange={validation.handleChange}
              PlaceHolder={"DD/MM/YYYY"}
              Error={
                validation.touched.startDate && validation.errors.startDate
                  ? true
                  : false
              }
              HelperText={
                validation.touched.startDate && validation.errors.startDate ? (
                  <MUIErrorText ErrorMessage={validation.errors.startDate} />
                ) : null
              }
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4, md: 4, lg: 4 }}>
            <Typography variant="body2" className="inter-regular-400 py-1">
              End Date
            </Typography>
            <MUIDatePicker
              Name={"endDate"}
              Id={"endDate"}
              Disabled={isViewMode || params.auditId ? true : false}
              Value={validation.values.endDate || ""}
              OnBlur={validation.handleBlur}
              OnChange={validation.handleChange}
              ShouldDisableCurrentDate={disablePreviousDateForEndDate}
              PlaceHolder={"DD/MM/YYYY"}
              Error={
                validation.touched.endDate && validation.errors.endDate
                  ? true
                  : false
              }
              HelperText={
                validation.touched.endDate && validation.errors.endDate ? (
                  <MUIErrorText ErrorMessage={validation.errors.endDate} />
                ) : null
              }
            />
          </Grid2>
          <Grid2
            size={{
              xs: 12,
              sm: 4,
              md: showSaveChangesBtn ? 3 : 4,
              lg: showSaveChangesBtn ? 3 : 4,
            }}
          >
            <Typography variant="body2" className="inter-regular-400 py-1">
              Auditor
            </Typography>
            {/* <AppInputField
              Name={"auditorId"}
              Id={"auditorId"}
              PlaceHolder={"Select Auditor"}
              IsSelect={true}
              SelectOptions={auditorList || []}
              Disabled={isDropdownDisabled || !isBranchOrDeptSelected}
              Value={validation.values.auditorId || ""}
              OnBlur={validation.handleBlur}
              OnChange={validation.handleChange}
              Error={
                validation.touched.auditorId && validation.errors.auditorId
                  ? true
                  : false
              }
              HelperText={validation.errors.auditorId}
            /> */}
            <AppAutoCompleteField
              IsMultiple={false}
              TextInputName={"auditorId"}
              TextInputId={"auditorId"}
              Id={"auditorId"}
              TextInputPlaceholder={"Select Auditor"}
              Options={auditorList || []}
              Disabled={isDropdownDisabled || !isBranchOrDeptSelected}
              Value={validation.values.auditorId || ""}
              HandleOnBlur={validation.handleBlur}
              HandleOnChange={(event, value_) => {
                handleChangeForFields(event, "auditorId", value_?.value || "");
              }}
              TextInputError={
                validation.touched.auditorId && validation.errors.auditorId
                  ? true
                  : false
              }
              TextInputHelperText={
                validation.touched.auditorId && validation.errors.auditorId
                  ? validation.errors.auditorId
                  : null
              }
            />
          </Grid2>
          <Grid2
            size={{
              xs: 12,
              sm: 4,
              md: showSaveChangesBtn ? 3 : 4,
              lg: showSaveChangesBtn ? 3 : 4,
            }}
          >
            <Typography variant="body2" className="inter-regular-400 py-1">
              Auditee
            </Typography>
            {/* <AppInputField
              Name={"auditeeId"}
              Id={"auditeeId"}
              PlaceHolder={"Select Auditee"}
              IsSelect={true}
              SelectOptions={auditeeList || []}
              Disabled={isDropdownDisabled || !isBranchOrDeptSelected}
              Value={validation.values.auditeeId || ""}
              OnBlur={validation.handleBlur}
              OnChange={validation.handleChange}
              Error={
                validation.touched.auditeeId && validation.errors.auditeeId
                  ? true
                  : false
              }
              HelperText={validation.errors.auditeeId}
            /> */}
            <AppAutoCompleteField
              IsMultiple={false}
              TextInputName={"auditeeId"}
              TextInputId={"auditeeId"}
              Id={"auditeeId"}
              TextInputPlaceholder={"Select Auditee"}
              Options={auditeeList || []}
              Disabled={isDropdownDisabled || !isBranchOrDeptSelected}
              Value={validation.values.auditeeId || ""}
              HandleOnBlur={validation.handleBlur}
              HandleOnChange={(event, value_) => {
                handleChangeForFields(event, "auditeeId", value_?.value || "");
              }}
              TextInputError={
                validation.touched.auditeeId && validation.errors.auditeeId
                  ? true
                  : false
              }
              TextInputHelperText={
                validation.touched.auditeeId && validation.errors.auditeeId
                  ? validation.errors.auditeeId
                  : null
              }
            />
          </Grid2>
          {showSaveChangesBtn && (
            <Grid2 size={{ xs: 12, sm: 4, md: 2, lg: 2 }} className="ms-auto">
              {!isMobileDevice && (
                <Typography
                  variant="body2"
                  className="inter-regular-400 py-1"
                  style={{
                    visibility: "hidden",
                  }}
                >
                  Select Auditee
                </Typography>
              )}
              <AppButton
                Type={"button"}
                OnPress={EditAudit}
                children={"Save Changes"}
              />
            </Grid2>
          )}
        </Grid2>

        <Divider
          className="my-2"
          style={{ color: "GrayText", border: "0.02rem solid GrayText" }}
        />
        {isCreateMode && !params?.auditId ? (
          <Grid2 container spacing={2} className="my-2">
            <Grid2 size={12}>
              <div className="d-flex align-items-center">
                <Typography variant="body1" className="inter-medium-500 py-1">
                  Activity List
                </Typography>
                {/* {!params?.auditId && (
                  <div className="ms-auto">
                    <AppButton
                      IsDisabled={isViewMode || isUpdateMode}
                      ClassName={"px-3"}
                      OnPress={() => toggleModalState("activityList")}
                    >
                      {params.auditId ? "Update Activities" : "Add More"}
                    </AppButton>
                  </div>
                )} */}
              </div>
              <ExpandableList
                listData={activityList}
                modalData={[]}
                showMoreOrLess={showMoreOrLess}
                showMoreOrLessKey={"activityList"}
                toggleShowMoreOrLess={toggleShowMoreOrLess}
                renderListItem={(item) => item.name}
                sliceCount={5}
              />
            </Grid2>
          </Grid2>
        ) : (
          <Grid2 container spacing={2} className="my-2">
            <Grid2 size={12}>
              <DataTableToUpdateActivityStatusForAudit
                Columns={dataTableColumnsForUpdateActivityStatus}
                AuditData={dataThroughLocationState || null}
                RowData={activityStatusTable || []}
                HandleChangeInActivityStatusTable={(id, field, value) => {
                  handleChangeInActivityStatusTable(id, field, value);
                }}
                IsAdmin={isAdmin}
                IsSuperAdmin={isSuperAdmin}
                IsAuditor={isAuditor}
                IsAuditee={isAuditee}
                IsUser={isUser}
                IsViewMode={isViewMode && params?.auditId ? true : false}
                IsAuditReviewedByAuditor={isAuditReviewedByAuditor}
                IsAuditReviewedByAuditee={isAuditReviewedByAuditee}
                IsAuditInClosePendingStatus={isAuditInClosePendingStatus}
                IsAuditReviewPendingAtAuditor={isAuditReviewPendingAtAuditor}
                IsAuditInClosedStatus={isAuditInClosedStatus}
                IsAuditStatusNew={isAuditStatusNew}
                IsAuditStarted={isAuditStarted}
                DenseTable={true}
                RowsToDisplay={10}
                OptionsForRowsPerPage={[5, 10, 15, 25, 50]}
                IsOutSideSearch={true}
                UploadEvidenceModalState={uploadEvidenceModalState}
                HandleToggleUploadEvidenceModalState={
                  handleToggleUploadEvidenceModalState
                }
              />
            </Grid2>
            <Grid2 size={12}>
              <Typography variant="body1" className="inter-regular-400 py-1">
                Auditor Suggestion
              </Typography>
              <AppInputField
                Name={"auditorsSuggestion"}
                Id={"auditorsSuggestion"}
                PlaceHolder={"Auditor Suggestion"}
                IsMultiLine={true}
                MaxRows={5}
                Disabled={
                  // isAdmin ||
                  // isSuperAdmin ||
                  !isAuditStarted ||
                  isAuditee ||
                  isViewMode ||
                  ((isSuperAdmin || isAdmin) && !isAuditor) ||
                  (isAuditReviewedByAuditor && isAuditor) ||
                  (isAuditReviewedByAuditee && isAuditor) ||
                  isAuditInClosedStatus
                  // || (isAuditInClosePendingStatus && isAuditor)
                }
                Value={suggestion.auditorsSuggestion}
                OnChange={handleSuggestion}
              />
            </Grid2>
            <Grid2 size={12}>
              <Typography variant="body1" className="inter-regular-400 py-1">
                Auditee Suggestion
              </Typography>
              <AppInputField
                Name={"auditeesSuggestion"}
                Id={"auditeesSuggestion"}
                PlaceHolder={"Auditee Suggestion"}
                IsMultiLine={true}
                MaxRows={5}
                Disabled={
                  // isAdmin ||
                  // isSuperAdmin ||
                  !isAuditStarted ||
                  isAuditor ||
                  isViewMode ||
                  ((isSuperAdmin || isAdmin) && !isAuditee) ||
                  (isAuditStatusNew && isAuditee) ||
                  (isAuditInClosePendingStatus && isAuditee) ||
                  isAuditInClosedStatus
                }
                Value={suggestion.auditeesSuggestion}
                OnChange={handleSuggestion}
              />
            </Grid2>
          </Grid2>
        )}

        <div
          style={{
            display: "flex",
            marginTop: "auto",
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Grid2 container spacing={2} className="mt-2 pb-3 w-100">
            {!params.auditId && (
              <Grid2 size={{ xs: 6, sm: 6, md: 6, lg: 6 }}>
                <AppButton
                  Type={"reset"}
                  OnPress={() => {
                    validation.handleReset();
                  }}
                  children={"Reset"}
                  Color={"error"}
                />
              </Grid2>
            )}

            {!shouldHideUpdateButton &&
              !shouldHideUpdateButtonForAuditeeAndAuditor &&
              !(isAuditStatusNew && isAuditee) &&
              (!params?.auditId ||
                (params?.auditId && isUpdateMode && isAuditStarted)) && (
                <Grid2
                  size={{
                    xs: params.auditId ? 12 : 6,
                    sm: params.auditId ? 12 : 6,
                    md: params.auditId ? 12 : 6,
                    lg: params.auditId ? 12 : 6,
                  }}
                >
                  <AppButton
                    Type={"submit"}
                    IsDisabled={
                      (isAuditReviewedByAuditee && isAuditor) ||
                      (isAuditReviewedByAuditor && isAuditor)
                    }
                    OnPress={() => {
                      if (navigator.onLine) {
                        validation.handleSubmit();
                      } else {
                        showSnackbar(
                          ERROR_MESSAGE.INTERNET_ERROR,
                          SNACKBAR_VARIANT.ERROR
                        );
                      }
                    }}
                    children={params.auditId ? "Update" : "Create"}
                  />
                </Grid2>
              )}

            {isAuditor &&
              params?.auditId &&
              !isViewMode &&
              isAuditInClosePendingStatus && (
                <AppButton
                  Type={"submit"}
                  Color={"error"}
                  OnPress={() => {
                    if (navigator.onLine) {
                      const payload = {
                        auditId: dataThroughLocationState?.id,
                        accountId: accountId,
                        updatedBy: userUid,
                        auditorsSuggestion: suggestion.auditorsSuggestion,
                        activityList: activityStatusTable.map(
                          ({ id, ...rest }) => rest
                        ),
                      };
                      handleToggleFinalSaveModalState(
                        "Close Audit",
                        payload,
                        true
                      );
                      // finalCloseOfAuditForAuditor(payload);
                    } else {
                      showSnackbar(
                        ERROR_MESSAGE.INTERNET_ERROR,
                        SNACKBAR_VARIANT.ERROR
                      );
                    }
                  }}
                  children={"Close"}
                />
              )}
          </Grid2>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateNewAudit;
